module.exports = __webpack_public_path__ + "img/1.8349962b.jpg";